import React from 'react'
import { DotButton, useDotButton } from './dotbutton'
import useEmblaCarousel from 'embla-carousel-react'

const EmblaCarousel = ({ items = [], options }) => {
    const [emblaRef, emblaApi] = useEmblaCarousel(options)
    const { selectedIndex, scrollSnaps, onDotButtonClick } = useDotButton(emblaApi)

      return (
            <section className="embla">
                <div className="embla__viewport" ref={emblaRef}>
                    <div className="embla__container">
                    {items.map((item, index) => (
                        <div className="embla__slide" key={index}>
                            {/* <div className="embla__slide__number">{index + 1}</div> */}
                                <img alt='event_image' src={item} className='header_image'
                                style={{
                                    height: '70vh',
                                    width: '100%',
                                    objectFit: 'fill'
                                }} />
                        </div>
                    ))}
                    </div>
                </div>

                <div className="embla__controls">
                    <div className="embla__dots">
                    {scrollSnaps.map((_, index) => (
                        <DotButton
                        key={index}
                        onClick={() => onDotButtonClick(index)}
                        className={'embla__dot'.concat(
                            index === selectedIndex ? ' embla__dot--selected' : ''
                        )}
                        />
                    ))}
                    </div>
                </div>
            </section>
        )
}


export default EmblaCarousel
